import { render, staticRenderFns } from "./TicketForwarding.vue?vue&type=template&id=5a908e94"
import script from "./TicketForwarding.vue?vue&type=script&lang=js"
export * from "./TicketForwarding.vue?vue&type=script&lang=js"
import style0 from "./TicketForwarding.vue?vue&type=style&index=0&id=5a908e94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports